import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';

import { UserApiService } from '../../shared/services/api/user-api.service';
import { PRICE_BAND_RUN_MANAGE } from './price-band-run-permissions';

/**
 * Route guard for the Review Bands run-publication admin surface
 * (`/admin/price-band-runs`), GF-4979.
 *
 * Reads the caller's DB-granted permissions from `GET /user/auth/me` and
 * activates the route only if `price_band_run.manage` is present. Tenant
 * users and super_users without the grant are bounced to `/home`.
 */
export const priceBandRunAdminGuard: CanActivateFn = async () => {
  const userApi = inject(UserApiService);
  const router = inject(Router);
  try {
    const me = await firstValueFrom(userApi.getUserData());
    if (me.permissions?.includes(PRICE_BAND_RUN_MANAGE)) {
      return true;
    }
  } catch {
    // Network / auth issues fall through to redirect — the authTokenInterceptor
    // already handles the 401/403 cases at the HTTP layer.
  }
  return router.createUrlTree(['/home']);
};
